import { InjectionToken } from "@angular/core";

export const DATE_FORMAT = new InjectionToken<string>("Date format used for datetime module things");
